import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent" />
          <p className="mt-4 text-slate-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (user.is_admin) return children;

  const bypassPaths = ['/verification', '/settings', '/profile'];
  if (user.verification_status !== 'approved' && !bypassPaths.some(p => location.pathname.startsWith(p))) {
    return <Navigate to="/verification" replace />;
  }

  return children;
};

export default ProtectedRoute;
